<div class="input-main-container ym-display-flex ym-flex-direction-column ym-gap-2" [class.error-occured]="error">
    <div class="label-container ym-display-flex ym-align-items-center ym-gap-3">
        <div class="ym-text-color ym-display-flex ym-align-items-center ym-gap-2 ym-w-full">
            <span class="text ym-font-base ym-line-height-normal">Options</span>
        </div>
        <div class="actions ym-h-5 ym--flex-center ym-mr-n3">
            <ym-button [type]="buttonTypes.GHOST_LINK" [size]="buttonSizes.SM"
                (onClick)="sortOptionsAlphabetically()">Sort alphabetically</ym-button>
        </div>
    </div>

    <div class="options-container ym-border-1 ym-border-solid ym-border-gray-a-16 ym-rounded-lg ym-overflow-hidden">
        <div class="options-container-header ym-display-flex ym-gap-3 ym-pr-5 ym-pt-3 ym-pb-2 ym-bg-gray-10 ym-mb-3">
            <div class="ym-w-7 ym-flex-shrink-0"></div>
            <div class="ym-w-full ym-line-height-32">Label</div>
            <div class="ym-w-full ym-line-height-32">Internal name</div>
            <div class="ym-w-7 ym-flex-shrink-0"></div>
        </div>

        <div cdkDropList (cdkDropListDropped)="drop($event)">
            <ng-container *ngFor="let option of displayOption; let i = index">
                <div cdkDrag>
                    <ng-template #optionValue let-index="index" let-label="label" let-value="value">
                        <div
                            class="field-container ym-bg-white ym-pr-5 ym-transition-duration-medium ym-hover-bg-gray-10 ym-display-flex ym-gap-3 ym-align-items-flex-start">
                            <span class="drag icon ym-svg-md ym-text-secondary ym-cursor-grab ym-py-4 ym-mt-1 ym-pl-4"
                                cdkDragHandle>
                                <ym-icon [iconName]="iconNames.GRIP_VERTICAL"></ym-icon>
                            </span>
                            <span class="info ym-w-full ym-display-flex ym-gap-3 ym-py-3">
                                <ym-input #labelInput [showLabel]="false" [value]="label"
                                    [error]="option.isLabelInvalid" [errorText]="option.labelErrorText"
                                    (valueInput)="updateLabel(i, $event)" class="ym-w-full"></ym-input>
                                <ym-input [showLabel]="false" [value]="value" [disabled]="option.isDisabled"
                                    [error]="option.isValueInvalid" [errorText]="option.valueErrorText"
                                    (valueInput)="updateValue(i, $event)" class="ym-w-full"></ym-input>
                            </span>
                            <span class="action ym-display-flex ym-gap-3 ym-py-3">
                                <ym-button [variant]="buttonVariants.ICON_ONLY" [icon]="iconNames.DELETE"
                                    [type]="buttonTypes.GHOST" [tooltip]="'Remove'" (onClick)="removeOption(i)"
                                    [disabled]="displayOption.length < 2"></ym-button>
                            </span>
                        </div>
                    </ng-template>

                    <ng-container
                        *ngTemplateOutlet="optionValue; context:{index: i, label: option.label, value: option.value}"></ng-container>
                </div>
            </ng-container>
        </div>

        <div class="options-container-footer ym-display-flex ym-gap-3 ym-px-3 ym-py-3 ym-bg-gray-10 ym-mt-3">
            <ym-button [variant]="buttonVariants.ICON_AND_TEXT" [icon]="iconNames.PLUS" [type]="buttonTypes.GHOST_LINK"
                (onClick)="addOption()">Add
                option</ym-button>
        </div>
    </div>
    <span class="error-text ym-font-sm ym-text-danger ym-display-block ym-line-height-normal"
        *ngIf="error">{{errorText}}</span>
</div>